var exports = {
  "link": "x24da60e8--86512d--link",
};

module.exports = exports;
